<template>
  <div>
    <!--      <nav-bar :is-white-navbar="false" :navLight="true"></nav-bar>-->
    <Gnb :headers="headers" />
    <div class="contents">
      <router-view />
    </div>
    <div>
      <pinx-footer class="webFooter"></pinx-footer>
      <PinxFooterMobile :class="{mobileFooter: !isReservation, hidden: isReservation}"></PinxFooterMobile>
    </div>
  </div>
</template>

<script>
import PinxFooter from '@/components/PinxFooter';
import PinxFooterMobile from '@/components/PinxFooter_mobile';
import Gnb from '@/components/Gnb';

export default {
  components: {Gnb, PinxFooter, PinxFooterMobile},

  data() {
    return {
      isReservation: false,
      isLang: true,
      headers: null,
      headers_ko: [
        {
          topMenu: 'ABOUT',
          // topMenu: '호텔소개',
          subMenu: [
            {
              link: '/p/introduce',
              text: 'P-Leisure 소개',
            },
            {
              link: '/p/Notice',
              text: '공지사항',
            },
            {
              link: '/p/Newsroom',
              text: '뉴스룸',
            },
            {
              link: '/p/Photoview',
              text: '포토뷰',
            },
          ],
        },
        {
          topMenu: 'PROGRAM',
          // topMenu: '식사',
          subMenu: [
            {
              link: '/p/Program',
              text: ' 프로그램 안내',
            },
          ],
        },
        {
          topMenu: 'SPECIAL OFFERS',
          // topMenu: '특별주문',
          subMenu: [
            // {
            //   link: '/p/Eventpromotion',
            //   text: '이벤트&프로모션',
            // },
            {
              link: '/p/Premiumbenefits',
              text: '프리미엄 혜택',
            },
            /*{
              link: '/p/Optionprogram',
              text: '옵션 프로그램',
            },*/
          ],
        },
        {
          topMenu: 'RESERVATION',
          // topMenu: '객실예약',
          subMenu: [
            {
              link: '/p/Reservinfo',
              text: '예약안내',
            },
            {
              link: '/p/Realtimebooking2',
              text: '프로그램 예약',
            },
          ],
        },
        // '',
        // '',
        // '',
        // '',
        // '',
        // '',
      ],
      headers_en: [
        {
          topMenu: 'ABOUT',
          // topMenu: '호텔소개',
          subMenu: [
            {
              link: '/p/introduce',
              text: 'P-Leisure Introduction',
            },
            {
              link: '/p/Photoview',
              text: 'Photo View',
            },
          ],
        },
        {
          topMenu: 'PROGRAM',
          // topMenu: '식사',
          subMenu: [
            {
              link: '/p/Program',
              text: 'Program Information',
            },
          ],
        },
        {
          topMenu: 'SPECIAL OFFERS',
          // topMenu: '특별주문',
          subMenu: [
            {
              link: '/p/Premiumbenefits',
              text: 'Premium Benefits',
            },
            /*{
              link: '/p/Optionprogram',
              text: 'Option Program',
            },*/
          ],
        },
        {
          topMenu: 'RESERVATION',
          // topMenu: '객실예약',
          subMenu: [
            {
              link: '/p/Reservinfo',
              text: 'Reservation Guide',
            },
          ],
        },
        // '',
        // '',
        // '',
        // '',
        // '',
        // '',
      ],
      headers_jp: [
        {
          topMenu: 'ABOUT',
          // topMenu: '호텔소개',
          subMenu: [
            {
              link: '/p/introduce',
              text: 'P-Leisure 소개',
            },
            {
              link: '/p/Notice',
              text: '공지사항',
            },
            {
              link: '/p/Newsroom',
              text: '뉴스룸',
            },
            {
              link: '/p/Photoview',
              text: '포토뷰',
            },
          ],
        },
        {
          topMenu: 'PROGRAM',
          // topMenu: '식사',
          subMenu: [
            {
              link: '/p/Program',
              text: ' 프로그램 안내',
            },
          ],
        },
        {
          topMenu: 'SPECIAL OFFERS',
          // topMenu: '특별주문',
          subMenu: [
            // {
            //   link: '/p/Eventpromotion',
            //   text: '이벤트&프로모션',
            // },
            {
              link: '/p/Premiumbenefits',
              text: '프리미엄 혜택',
            },
            /*{
              link: '/p/Optionprogram',
              text: '옵션 프로그램',
            },*/
          ],
        },
        {
          topMenu: 'RESERVATION',
          // topMenu: '객실예약',
          subMenu: [
            {
              link: '/p/Reservinfo',
              text: '예약안내',
            },
            {
              link: '/p/Realtimebooking2',
              text: '프로그램 예약',
            },
          ],
        },
        // '',
        // '',
        // '',
        // '',
        // '',
        // '',
      ],
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.headers = this.headers_ko;
      } else if (newVal === 'en') {
        this.headers = this.headers_en;
      } else if (newVal === 'ja') {
        this.headers = this.headers_jp;
      } else {
        this.headers = this.headers_ko;
      }
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
    $route(to, from) {
      this.refreshLocale(this.$i18n.locale);
      console.log('INDEX-WATCH', to, from);
      if (to.path === '/p/Realtimebooking2') {
        this.isReservation = true;
      } else {
        this.isReservation = false;
      }
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
    if (this.$route.path === '/p/Realtimebooking2') {
      this.isReservation = true;
    } else {
      this.isReservation = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.contents {
  padding-bottom: 3rem;
}
.webFooter {
  display: block;
}
.mobileFooter {
  display: none;
}

.hidden {
  display: none;
}

@media (max-width: 992px) {
  .webFooter {
    display: none;
  }
  .mobileFooter {
    display: block;
    padding-bottom: 2rem;
  }
}
</style>
